import { render, staticRenderFns } from "./TableVisualizar.vue?vue&type=template&id=dc0d106e"
import script from "./TableVisualizar.vue?vue&type=script&lang=js"
export * from "./TableVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports